import { h, Host } from "@stencil/core";
import { BEM } from "../../../utils/bem";
import { inheritAttributes } from "../../../utils/attributes";
import { rOnLoad } from "../../../utils/helpers";
export class StageImage {
    constructor() {
        this.imageInheritAttributes = {};
        this.isOnLoadEventDone = false;
        this.srcSet = undefined;
        this.fallback = undefined;
    }
    componentDidLoad() {
        rOnLoad(() => {
            this.isOnLoadEventDone = true;
        });
    }
    componentWillLoad() {
        this.imageInheritAttributes = inheritAttributes(this.el, ['alt']);
    }
    render() {
        const block = BEM.block('stage-image');
        const imageSrc = this.fallback ? this.fallback : this.srcSet.split(',')[0];
        return (h(Host, { key: '49e208ba82916b7d7952129e94919e8d82496c22', class: Object.assign({}, block.class()) }, this.isOnLoadEventDone ? (h("img", Object.assign({ src: imageSrc, srcset: this.srcSet, sizes: "100vw" }, this.imageInheritAttributes))) : ('')));
    }
    static get is() { return "bal-stage-image"; }
    static get properties() {
        return {
            "srcSet": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "set of images to be used as background image"
                },
                "getter": false,
                "setter": false,
                "attribute": "src-set",
                "reflect": false
            },
            "fallback": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "optional fallback image in case the srcSet fails"
                },
                "getter": false,
                "setter": false,
                "attribute": "fallback",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "isOnLoadEventDone": {}
        };
    }
    static get elementRef() { return "el"; }
}
